import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerStoresFilter: {
        flexDirection: 'row',
        marginHorizontal: 6,
    },
    flatList: {
        flex: 1,
        flexGrow: 1,
    },
    containerWelcomeMessage: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: 10,
        padding: 12,
        borderRadius: 15,
        borderWidth: 0.2,
        borderColor: theme.colors.mediumGray,
    },
    textTitleWelcomeMessage: {
        flex: 1,
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginBottom: 4,
    },
    textDescriptionWelcomeMessage: {
        flex: 1,
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    containerCloseButton: {
        flex: 1,
        alignItems: 'center',
    },
    textClose: {
        fontSize: 15,
        lineHeight: 19,
        fontWeight: 'normal',
        color: theme.colors.error,
        maxWidth: '85%',
    },
    containerCampaignData: {
        marginHorizontal: 12,
        paddingVertical: 16,
        marginBottom: 16,
        borderRadius: 15,
    },
    containerProgress: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 5,
        paddingHorizontal: 12,
    },
    containerSection: {
        flexDirection: 'column',
        backgroundColor: theme.colors.formsBackground,
        //paddingHorizontal: 15,
        paddingRight: 40,
        paddingVertical: 20,
        marginTop: 10,
    },
    containerSectionInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
    },
    containerVacationAlert: {
        flex: 1,
        height: height - 200,
        justifyContent: 'center',
    },
    cardStore: {
        borderColor: theme.colors.lightGray,
        flex: 1,
        justifyContent: 'center',
        borderWidth: 0.5,
        borderRadius: 10,
        marginVertical: 5,
        padding: 10,
        backgroundColor: 'white',
    },
    textDate: {
        fontSize: 20,
        color: theme.colors.textPrimary,
        marginLeft: 12,
        width: '70%',
    },
    date: {
        fontSize: 18,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
    },
    textDateJTI: {
        fontSize: 20,
        color: theme.colors.textPrimary,
        marginLeft: 12,
        width: '75%',
    },
    textCampaign: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingLeft: 10,
        paddingBottom: 15,
    },
    textCampaignDate: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        paddingRight: 10,
        paddingBottom: 15,
        textAlign: 'left',
    },
    textSection: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
    },
    containerData: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 5,
    },
    containerDailySurvey: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: 16,
        marginRight: 32,
        paddingBottom: 16,
    },
    containerFormCompleted: {
        flexDirection: 'row',
        alignItems: 'baseline',
        paddingHorizontal: 12,
    },
    containerFormsCompleted: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginHorizontal: 12,
        paddingTop: 16,
    },
    dividerVerticalLine: {
        borderLeftWidth: 1,
        borderLeftColor: theme.colors.lightGray,
        height: '100%',
    },
    textPercentage: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
        paddingRight: 8,
    },
    containerInfoStore: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    statusImage: {
        width: 20,
        height: 20,
        margin: 4,
    },
    storeImage: {
        width: 20,
        height: 20,
        marginRight: 5,
    },
    textNameStore: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginVertical: 5,
    },
    textMA: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        marginBottom: 5,
    },
    textAddressStore: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginBottom: 5,
    },
    textQuestion: {
        fontSize: 15,
        fontWeight: '500',
        color: theme.colors.textPrimary,
        marginBottom: 6,
    },
    textAnswer: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 12,
    },
    textAddressStoreWithGoTo: {
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 5,
        textDecorationLine: 'underline',
    },
    textCodeStore: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    textDistanceStore: {
        fontSize: 12,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    textAddressStoreJTI: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 5,
    },
    textInfoStore: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 5,
    },
    containerCampaignHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: 16,
        marginRight: 12,
    },
    textSurvey: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
    },
    textInfoSurvey: {
        fontSize: 14,
        fontWeight: 'normal',
        color: 'white',
        paddingRight: 12,
    },
    containerGoToMap: {
        flexDirection: 'row',
        paddingLeft: 0,
        paddingRight: 6,
        paddingVertical: 4,
        borderRadius: 5,
        backgroundColor: theme.colors.colorPrimary,
    },
    textGoToMap: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        paddingLeft: 10,
        paddingRight: 5,
    },
    textLastVisit: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginVertical: 5,
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        width: '100%',
        //marginVertical: 10,
    },
    statusModuleList: {
        justifyContent: 'center',
        alignContent: 'center',
        marginVertical: 2,
        paddingLeft: 5,
        paddingRight: 8,
        paddingVertical: 5,
        borderRadius: 5,
        alignSelf: 'flex-start',
    },
    statusModuleText: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    circleTag: {
        flexDirection: 'row',
        width: 28,
        height: 28,
        borderRadius: 15,
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
    },
    textCircleTag: {
        fontSize: 8,
        textTransform: 'uppercase',
        fontWeight: '900',
        color: 'white',
    },
    textDistance: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingLeft: 5,
    },
    containerCampaignProgress: {
        flexDirection: 'row',
        width: '95%',
        height: 10,
        borderRadius: 5,
        overflow: 'hidden',
        backgroundColor: 'white',
        marginRight: 12,
    },
    containerReferences: {
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        marginBottom: 5,
        marginHorizontal: 15,
    },
    circlesReferences: {
        width: 12,
        height: 12,
        borderRadius: 6,
    },
    textReferences: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingLeft: 5,
        paddingRight: 10,
        textAlign: 'left',
    },
    textForm: {
        fontSize: 12,
        fontWeight: 'bold',
        color: 'white',
        paddingRight: 8,
    },
    textFormDate: {
        fontSize: 10,
        fontWeight: 'normal',
        color: 'white',
    },
    formButton: {
        flexDirection: 'row',
        height: 36,
        marginTop: 15,
        marginHorizontal: 12,
        backgroundColor: 'white',
        borderWidth: 1.5,
        borderColor: 'white',
        padding: 5,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
    alertImage: {
        width: 20,
        height: 20,
        aspectRatio: 1,
    },
    buttonContainer: {
        flexDirection: 'column',
        padding: 15,
        bottom: 15,
        width: width,
    },
    borderButton: {
        flexDirection: 'row',
        marginTop: 10,
        marginHorizontal: 14,
        backgroundColor: 'white',
        borderColor: theme.colors.error,
        borderWidth: 2.0,
        paddingHorizontal: 5,
        paddingVertical: 8,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    borderButtonText: {
        fontSize: 15,
        color: theme.colors.error,
        fontWeight: 'bold',
    },
    mainButton: {
        flexDirection: 'row',
        marginTop: 10,
        marginRight: 10,
        backgroundColor: theme.colors.colorPrimary,
        paddingHorizontal: 5,
        paddingVertical: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 15,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'right',
        paddingLeft: 15,
    },
    showMore: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        paddingLeft: 10,
        paddingBottom: 15,
    },
    blockedView: {
        flex: 1,
        opacity: 0.5,
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    containerIconButtons: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        paddingRight: 6,
    },
    iconButton: {
        padding: 6,
    },
    input: {
        height: 40,
        borderWidth: 0.5,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        paddingHorizontal: 10,
        marginHorizontal: 12,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputdrop: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: 40,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 0,
        paddingRight: 10,
        marginHorizontal: 0,
        marginTop: 0,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputDropdownMenuSubsection: {
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
        color: theme.colors.textPrimary,
    },
    subtitle: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    containerRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    dropdown: {
        borderWidth: 0.5,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        marginTop: 0,
        marginHorizontal: 12,
    },
    dropdownOptions: {
        color: theme.colors.textPrimary,
    },
    dropdownInput: {
        color: theme.colors.textPrimary,
    },
    pitchButtonActive: {
        flexDirection: 'row',
        height: 36,
        marginHorizontal: 12,
        marginBottom: 12,
        backgroundColor: 'white',
        borderWidth: 1.0,
        borderColor: theme.colors.colorPrimary,
        padding: 5,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 15,
    },
    pitchButtonInactive: {
        flexDirection: 'row',
        height: 36,
        marginHorizontal: 12,
        marginBottom: 12,
        backgroundColor: theme.colors.disabled,
        borderWidth: 1.0,
        borderColor: theme.colors.disabled,
        padding: 5,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 15,
    },
    pitchButtonTextActive: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.colorPrimary,
        marginLeft: 4,
    },
    pitchButtonTextInactive: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        marginLeft: 4,
    },
    containerNoProducts: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
    },
    containerNoProductsBis: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        marginBottom: 12,
        marginVertical: 30,
    },
    containerOnVacation: {
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 20,
    },
    image: {
        width: 140,
        height: 140,
    },
    section: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'left',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 35,
    },
    titleActiv: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'left',
    },
    descriptionActiv: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'left',
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    flexDirectionRow: { flexDirection: 'row' },
    flexDirectionRowBis: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' },
    bold: { fontWeight: 'bold', fontSize: 16 },
    normal: { fontWeight: 'normal', fontSize: 16 },
    toggleButton: {
        padding: 10,
        borderRadius: 8,
        alignItems: 'center',
        borderColor: theme.colors.textPrimary,
        marginHorizontal: 15,
        borderWidth: 1,
    },
    toggleButtonText: {
        color: theme.colors.textPrimary,
        fontSize: 16,
        fontWeight: 'bold',
    },
    list: {
        marginBottom: 10,
    },
    activityItem: {
        padding: 15,
        borderRadius: 8,
        marginBottom: 10,
    },
    activityText: {
        fontSize: 16,
    },
    noActivitiesText: {
        textAlign: 'center',
        color: theme.colors.textSecondary,
        marginTop: 10,
    },
    buttonCheck: {
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
    },
    asset: {
        flex: 1,
        width: 50,
        height: 50,
        marginRight: 10,
    },
    activity: {
        fontSize: 15,
        paddingLeft: 4,
        color: theme.colors.textPrimary,
        textAlign: 'left',
        fontWeight: 'normal',
        maxWidth: '85%',
    },
    activityStrikethrough: {
        fontSize: 15,
        paddingLeft: 4,
        color: theme.colors.textPrimary,
        textAlign: 'left',
        fontWeight: 'normal',
        maxWidth: '85%',
        textDecorationLine: 'line-through',
    },
    label: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 5,
        backgroundColor: theme.colors.colorSecondary,
        paddingHorizontal: 8,
        paddingVertical: 4,
    },
    labelBis: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 5,
        borderColor: theme.colors.colorSecondary,
        borderWidth: 0.5,
        backgroundColor: 'white',
        paddingHorizontal: 8,
        paddingVertical: 4,
    },
    frequency: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
    },
    frequencyBis: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.colorSecondary,
    },
    marginHorizontal: { marginHorizontal: 12 },
    marginLeft: { marginLeft: 4 },
    marginRight: { marginRight: 4 },
    marginLeftBis: { marginLeft: 12 },
    marginRightBis: { marginRight: 12 },
    paddingRight: { paddingRight: 4 },
    spaceBetween: {
        justifyContent: 'space-between',
    },
    spacer: { height: 12 },
    mainButtonRetry: {
        width: '100%',
        height: 40,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 5,
    },
    mainButtonTextRetry: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        paddingVertical: 8,
    },
    floatingButtonText: {
        color: 'white',
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'left',
        marginHorizontal: 12,
    },
})

export default styles
